// Pure search contracts shared by the server readers, Home, and the overlay.

export function normalizeSearchTerm(value) {
  const term = String(value || '').trim().toLowerCase();
  return { term, ready: term.length >= 2 };
}

export function searchRequestState(immediateValue, debouncedValue, baseEnabled) {
  const immediate = normalizeSearchTerm(immediateValue);
  const debounced = normalizeSearchTerm(debouncedValue);
  const settled = immediate.term === debounced.term;
  return {
    enabled: !!baseEnabled && immediate.ready && debounced.ready && settled,
    waiting: !!baseEnabled && immediate.ready && !settled,
  };
}

export function globalSearchKey(group, userId, term, cap) {
  return ['global-search', userId || 'no-account', group, term, cap];
}

export function searchAccessReady(query, userId) {
  return !!userId
    && !query?.isPending && !query?.isLoading && !query?.isFetching && !query?.isError
    && query?.data?.user?.id === userId;
}

export function mapDeskOrder(row) {
  return {
    id: row.id,
    source: 'desk',
    pi: row.pi_no || '',
    item_no: row.item_no || '',
    model: row.model_name || row.item_no || '',
    supplier: row.supplier_code || row.factory_code || '',
    collection: row.collection_code || '',
    material: row.material || '',
    status: row.status || '',
    order_date: row.order_date || '',
    route: { kind: 'desk', orderId: row.id },
  };
}

export function mapBookOrder(row) {
  return {
    id: row.id,
    source: 'book',
    pi: row.pi || '',
    item_no: row.item_no || '',
    model: row.item_no || '',
    supplier: row.supplier || '',
    collection: row.collection || '',
    material: row.material || '',
    status: row.status || row.order_status || '',
    order_date: row.order_date || '',
    route: { kind: 'book', lineId: row.id },
  };
}

export function mergeOrderResults(deskRows, bookRows, cap) {
  const seen = new Set();
  return [...(deskRows || []), ...(bookRows || [])].filter((row) => {
    const key = `${row.source}:${row.id}`;
    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  }).slice(0, cap);
}

export function mapAcetate(row, aliases = []) {
  return {
    id: row.id,
    acetate_no: row.acetate_no || '',
    colour_name: row.colour_name || '',
    colour_family: row.colour_family || '',
    finish: row.finish || '',
    swatch_a: row.swatch_a || '',
    swatch_b: row.swatch_b || '',
    aliases: aliases.filter(Boolean),
    route: { tab: 'acetateBank', code: row.acetate_no || '' },
  };
}

export function matchesAcetate(row, rawTerm) {
  const term = String(rawTerm || '').trim().toLowerCase();
  if (!term) return true;
  return [row.acetate_no, row.colour_name, row.colour_family, row.finish, ...(row.aliases || [])]
    .some((value) => String(value || '').toLowerCase().includes(term));
}
